import { ICON_BOX_SERVICES, LEAD_FORM } from "@/data/content";
import { LeadForm } from "@/components/LeadForm";

const IconBox = ({ service }) => {
  const Icon = service.icon;
  return (
    <div data-testid={service.testId} className="flex items-start gap-4 group">
      <div className="shrink-0 h-12 w-12 rounded-full border border-[#e6e6e6] bg-white flex items-center justify-center shadow-[0_6px_18px_rgba(2,2,2,0.06)] group-hover:border-[#ee2e24]/40 transition-colors duration-200">
        <Icon size={21} strokeWidth={1.75} className="text-[#ee2e24]" />
      </div>
      <div>
        <h5 className="font-nunito text-[12px] font-extrabold uppercase tracking-[0.14em] text-[#383838]">
          {service.title}
        </h5>
        <p className="mt-2 text-sm text-[#6e6e6e] leading-relaxed">{service.body}</p>
      </div>
    </div>
  );
};

export const ServicesBand = () => {
  const left = ICON_BOX_SERVICES.slice(0, 3);
  const right = ICON_BOX_SERVICES.slice(3, 6);

  return (
    <section id="services" data-testid="services-band" className="bg-white py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-8">
          <div className="space-y-9">
            {left.map((s) => (
              <IconBox key={s.key} service={s} />
            ))}
          </div>
          <div className="space-y-9">
            {right.map((s) => (
              <IconBox key={s.key} service={s} />
            ))}
          </div>

          {/* Lead form panel — same placement as original "Free SEO Analysis" column */}
          <div id="visibility-audit" data-testid="lead-form-panel" className="md:col-span-2 lg:col-span-1 scroll-mt-28">
            <h3 className="font-nunito text-2xl font-extrabold text-[#383838] heading-redul mb-6">
              {LEAD_FORM.heading}
            </h3>
            <LeadForm />
          </div>
        </div>
      </div>
    </section>
  );
};
